import React from 'react'
import { type MemberInformation } from 'services'
import { PersonAutocomplete } from 'components/international'

export interface MemberAutocompleteProps {
  member?: MemberInformation
  updateMember: (member: MemberInformation) => void
  filledPerson: boolean
  editable: boolean
  editing: boolean
  setEditing: (value: boolean) => void
  createPerson: boolean
  setCreatePerson: (value: boolean) => void
  chamberIds?: number[]
  majmin?: string
  stateId?: number
}

export const MemberAutocomplete = ({
  member,
  updateMember,
  chamberIds,
  majmin,
  stateId,
  ...rest
}: MemberAutocompleteProps): React.ReactElement => (
  <PersonAutocomplete<MemberInformation>
    person={member}
    updatePerson={updateMember}
    personType='member'
    memberFilterOptions={{ chamberIds, majmin, stateId }}
    {...rest}
  />
)
